import React from 'react';

// DJB-128: account-level constants, formatting and the state badge shared
// between the Accounts Overview table and the Dashboard stat widgets.

export const ACCOUNT_STATE_ORDER = ['pending', 'active', 'dormant', 'dead', 'suspended', 'archived'];

export const OVEREENKOMST_ORDER = ['BASIC', 'PRO', 'UNLIMITED', 'UNASSIGNED'];

export const OVEREENKOMST_LABELS = {
  BASIC: 'Basic',
  PRO: 'Pro',
  UNLIMITED: 'Unlimited',
  UNASSIGNED: 'Unassigned',
};

export const getOvereenkomstLabel = (overeenkomst) =>
  OVEREENKOMST_LABELS[overeenkomst] || overeenkomst || 'Unassigned';

// Belgisch bedrag-formaat: punt als duizendtal-scheiding, komma als decimaalteken (1.234,56 €)
const euroFormatter = new Intl.NumberFormat('nl-BE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatEuro = (cents) => `${euroFormatter.format((cents || 0) / 100)} €`;

export const AccountStateBadge = ({ state }) => {
  const normalized = (state || '').toLowerCase();
  return (
    <span className={`account-state-badge ${normalized}`}>
      {normalized || '—'}
    </span>
  );
};
